
import { NgModule }             from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { UserComponent }    from './user.component';

const SECURITY_ROUTES: Routes = [
  { path: 'security/user', component: UserComponent }
];

export const ROUTABLE_COMPONENTS = [
];

@NgModule({
  imports: [
    RouterModule.forChild(SECURITY_ROUTES)
  ],
  exports: [
    RouterModule
  ],
  providers: []
})
export class UserRoutingModule {}